<template>
  <div class="BaseInfo-root">
    <div v-if="noData" class="no-data">暂无数据</div>
    <div v-if="!noData">
      <div v-if="!onlyGpsPage" class="info-panel-first">
        <div class="car-info">
          <a
            v-for="(item, index) in dispatchList"
            :key="index"
            :class="['carBtn', carActIndex === index ? 'active' : '']"
            @click="carActIndex = index"
            >{{ item.licensePlate }}
          </a>
          <a-descriptions bordered :column="3" class="cardStyle">
            <a-descriptions-item label="派车单号">
              {{ filterOrder(form.shippingOrderNos) }}
            </a-descriptions-item>
            <a-descriptions-item label="司机姓名">
                {{ form.driverName }}
            </a-descriptions-item>
            <a-descriptions-item label="司机电话">
                {{ form.driverPhone }}
                <a class="show-phone" @click="showPhone(form.driverPhone)">查看号码</a>
            </a-descriptions-item>
            <!-- <a-descriptions-item label="司机类型">
              {{ form.driverType | driverTypeFilter }}
            </a-descriptions-item> -->
            <a-descriptions-item label="车牌号">
                {{ form.licensePlate }}
            </a-descriptions-item>
            <a-descriptions-item label="车型">
              {{ form.carType || '--' }}
            </a-descriptions-item>
            <!-- <a-descriptions-item label="车辆所属" :span="2">
                {{ form.carOwningSideName ? form.carOwningSideName : '/' }}
            </a-descriptions-item> -->
          </a-descriptions>
        </div>
        <car-line-or-goods v-if="carShow" :is-demo-data="isDemoData" class="info-panel" :data="waybillList" :order-goods-type="orderGoodsType" />
      </div>
      <map-gps
        v-if="filterStatus()&&initfetch"
        class="info-panel"
        :waybill-list="waybillList"
        :start-time="dispatchList && dispatchList.length > 0 ? dispatchList[carActIndex].startTransportTime : ''"
        :order-data="form"
        :order-detail="orderDetail"
        :dispatch="dispatchList && dispatchList.length > 0 ? dispatchList[carActIndex] : {}"
        :is-demo="isDemo"
      />
      <car-temperature
        v-if="showTemperature && !onlyGpsPage"
        ref="carTemperature"
        class="info-panel"
        :waybill-list="waybillList"
        :start-time="dispatchList && dispatchList.length > 0 ? dispatchList[carActIndex].startTransportTime : ''"
        :vehicle="form.licensePlate"
        :driver-phone="form.driverPhone"
      />
    </div>
  </div>
</template>

<script>
import { Modal } from 'ant-design-vue';
import { mapState,mapActions, mapGetters } from 'vuex'
import { getDispatchInfo } from "@/pages/orderManage/api.js";
import { DriverTypeText } from "@/pages/orderManage/constant.js";
import {MAP_FIELDS,RULE_TYPE} from '@/constants/ruleConfig'
import CarLineOrGoods from "./components/CarLineOrGoods";
import MapGps from "./components/CarGps.vue";
import CarTemperature from "./components/CarTemperature";
import {featchOrderDetailUnify} from '../api.js';

export default {
  name: "CarInfo",
  components: {
    CarLineOrGoods,
    MapGps,
    CarTemperature,
  },
  filters: {
    driverTypeFilter(val) {
      return DriverTypeText[val];
    },
  },
  props: {
    orderStatus: {
      type: String,
      default: "",
    },
    isDemoData: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      carActIndex: null,
      dispatchList: [],
      form: {
        shippingOrderNo: "",
        driverName: "",
        driverPhone: "",
        driverType: "",
        licensePlate: "",
        createTime: "",
      },
      orderNo: this.$route.query.odrNo,
      noData: false,
      orderDetail: {},
      carShow: true,
      orderGoodsType: 0,
      showTemperature: false,
      isDemo: false,
      initfetch:false,
    };
  },
  computed: {
    ...mapState('orderRules', ['sensitiveFields']),
    ...mapGetters('iframe', ['onlyGpsPage']),
    waybillList() {
      return this.form.waybillList || [];
    },
    isShowField(){
      return (field)=>{
        const {vehicleTrackSensitiveFields=[]} = this.sensitiveFields.SENSITIVE_FIELDS;
        return vehicleTrackSensitiveFields.includes(field)
      }
    }
  },
  watch: {
    carActIndex: {
      handler(val) {
        const current = this.dispatchList?.[val] || {}
        const { driverName = '' } = current;
        this.form = {
          ...current,
          driverName: this.isDemoData ? `${driverName.slice(0, 1)  }师傅` : driverName,
        };
      },
    },
    dispatchList(val){
      if(!val || val.length === 0){
        this.noData = true
      }else{
        this.noData = false
      }
    }
  },
  async created() {
    await this.getOrderCrop(RULE_TYPE.sensitiveFields)
    const showTemperatureList = JSON.parse(localStorage.getItem('showTemperatureList') || '[]')
    const { customerCode } = this.$store.state.user
    this.showTemperature = showTemperatureList.includes(customerCode)
    this.featchData()
    // 演示账号名单获取
    this.isDemo = this.isShowField(MAP_FIELDS.track)
    this.initfetch=true
  },
  mounted() {
  },
  methods: {
    ...mapActions('orderRules', ['getOrderCrop']),
    // 虚拟拨号
    async showPhone() {
      const {dispatchList, carActIndex} = this
      const res = await getDispatchInfo({
        unifyOrderNo: this.orderNo,
      }, {id: dispatchList[carActIndex].id, params:["driverPhone"],isAxn: true})
      if (res.secretNo) {
        Modal.info({
          title: () => '',
          width: 450,
          okText: '确认',
          icon: '',
          okType: 'link',
          maskClosable: true,
          class: 'phone-modal',
          content: h => h('div', {}, [
            h('p', '联系司机请拨打以下手机号，手机号将在2分钟内有效'),
            h('p', {class: 'tel-phone'}, res.secretNo),
          ]),
          onOk() {
          },
        });
      } else {
        this.$message.error(res)
      }
    },
    filterStatus(){
      return this.waybillList[this.carActIndex]?.waybillStatus !== 1
    },
    async featchData(){
      this.dispatchList = await getDispatchInfo({ unifyOrderNo: this.orderNo });
      this.carActIndex = 0;
      this.getOrderDetail();
    },
    async getOrderDetail() {
      if(this.$route.query.odrNo) {
        this.orderDetail = await featchOrderDetailUnify({
          unifyOdrNo: this.$route.query.odrNo
        })
        this.carShow = true
        this.orderGoodsType = this.orderDetail.orderGoodsType
      }
    },
    filterOrder(data) {
      return data && data.join('、')
    }
  },
};
</script>

<style lang="less" scoped>
.info-panel {
  margin-top: 10px;
}
.info-panel-first {
  padding: 30px 0 20px 0;
  background-color: #fff;
  .ant-btn {
    margin-right: 10px;
  }
  .car-info {
    padding: 0 20px;
  }
}
.no-data {
  padding: 100px 0 500px;
  text-align: center;
  font-size: 24px;
  color: #ccc;
  background: #fff;
  // margin-top: 20px;
}
/deep/ .ant-table-thead{
  background: #fafafa;
}
.carBtn{
  border: none;
  background-size: 100% 100%;
  display: inline-block;
  width: 108px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  color: #606266;
  margin-right: 16px;
  background-image: url('../../../assets/img/offcar_icon.png');
  &.active {
    color: #fff;
    background-image: url('../../../assets/img/oncar_icon.png');
  }
}
.cardStyle{
  margin-top: 24px;
}
.show-phone {
  margin-left: 12px;
}
</style>

<style lang="less">
.phone-modal {
  .ant-modal {
    text-align: center;
    .anticon-question-circle {
      display: none;
    }
    .ant-modal-confirm-body > .anticon + .ant-modal-confirm-title + .ant-modal-confirm-content {
      margin: 0;
    }
    .ant-modal-confirm-btns {
      float: none;
    }
  }
  .tel-phone {
    font-size: 24px;
    font-weight: 500;
  }
}
</style>
